import device from 'common/support/device';
import { fetchPlaybackV3Url as fetchPlaybackUrlV3Api } from 'support/api/SyncbakApi';
import { Providers, Provider, AppDispatch, ChannelKey } from 'app-types';
import { VideoCtvRedux } from 'store-types';
import { HttpClient } from 'support/api/api-types';

export const SYNCBAK_DATA = 'SYNCBAK_DATA' as const;
export const CLEAR_SYNCBAK_DATA = 'CLEAR_SYNCBAK_DATA' as const;

export const getParamountPlusMvpdId = (state: VideoCtvRedux) => {
  const ks = state.kitchenSink.data;

  const { syncbakMvpdId } = ks.providers.paramountplus;

  const { userPackage } = state.auth.paramountPlus.user.data ?? {};

  if (userPackage === 'CBS_ALL_ACCESS_LOW_COST_PACKAGE') {
    return 'pplusLCP';
  }
  return syncbakMvpdId;
};

export const getPlaybackUrl = (video: { playback: { isSyncbak: boolean }; network: ChannelKey } | null = null, authorizedProvider: Provider | null = null) => (
  dispatch: AppDispatch<VideoCtvRedux>,
  getState: () => VideoCtvRedux,
) => {
  const ks = getState().kitchenSink.data;

  if (!ks || !video?.playback.isSyncbak) return null;
  const { host, key } = ks.playback.syncbakV3;
  const resource = ks.networks[video.network]?.resourceId || null;

  const state = getState();
  let mvpdId;
  if (authorizedProvider === Providers.ADOBE) {
    const adobeState = state.auth.adobe;
    mvpdId = adobeState.authN?.mvpd;
  } else {
    mvpdId = getParamountPlusMvpdId(state);
  }
  const station = state?.geoInfo?.data?.stations;

  return dispatch(
    fetchPlaybackUrlSyncbakV3({
      host,
      key,
      resource,
      mvpdId,
      ...(station && station.length > 0 ? { station: station[0] } : {}),
    }),
  );
};

const fetchPlaybackUrlSyncbakV3 = ({
  host,
  key,
  resource,
  mvpdId,
  station,
}: {
  host: string;
  key: string;
  resource?: string | null;
  mvpdId?: string | null;
  station?: string;
}) => (dispatch: AppDispatch<VideoCtvRedux>) => {
  return dispatch({
    type: SYNCBAK_DATA,
    promise: (httpClient: HttpClient) =>
      device.getDeviceId().then((deviceId: string) =>
        fetchPlaybackUrlV3Api(httpClient, {
          baseUrl: host,
          publicKey: key,
          resource,
          mvpdId,
          deviceSerialNum: deviceId,
          station,
        }),
      ),
  });
};

export const clearPlaybackUrl = () => ({
  type: CLEAR_SYNCBAK_DATA,
});
